import { render } from "./Unsubscribe.vue?vue&type=template&id=c91e1780&scoped=true"
import script from "./Unsubscribe.vue?vue&type=script&lang=js"
export * from "./Unsubscribe.vue?vue&type=script&lang=js"

import "./Unsubscribe.vue?vue&type=style&index=0&id=c91e1780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91e1780"]])

export default __exports__